module.exports = {"serverUrl":"","cgiUrl":"https://mdm.asc-wines.com/cgi","b2bCgiUrl":"https://ascb2b.asc-wines.com/cgi","uploadUrl":"https://ascb2b.asc-wines.com/uploadFile","wxRedirectUrl":"","wxAppId":"wxbd12788156951c0a","codeUrl":"","port":80,"path":"/cgi","share":{"signature":{"url":"http://openapi.art2.humming-tech.com/cgi","cmd":"social/weixin/signature"},"app":{"title":"","desc":"","link":"","imgUrl":""}},"wx":{"appId":"wxc8b5692daa915d32","appKey":"0d1cddb11f9f70962ccbd9ca8129bf70"}}


//////////////////
// WEBPACK FOOTER
// ../src/js/config/product.json
// module id = 11
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39